import { render, staticRenderFns } from "./ownerDetailHisFee.vue?vue&type=template&id=7abbfcfc"
import script from "./ownerDetailHisFee.vue?vue&type=script&lang=js"
export * from "./ownerDetailHisFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports